import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { AppEventsContext } from '../contexts/AppEventsContext'

export function useCategoryViewed(
  title: string,
  url: string,
  level: number
): (node?: Element | null) => void {
  const { appEvent } = AppEventsContext.useContainer()
  const { ref, inView } = useInView({ triggerOnce: true })

  useEffect(() => {
    if (inView) {
      appEvent({
        event: 'page-category-viewed',
        url,
        level,
        title,
      })
    }
  }, [inView])

  return ref
}
